import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.5.27_@babel+core@7.28.4_@playwright+test@1.55.0_react-dom@19.2.1_react@19.2.1__react@19.2.1_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(frontend)/[slug]/page.client.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/blocks/RenderBlocks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/src/components/Button/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImageMedia"] */ "/app/src/components/Media/ImageMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoMedia"] */ "/app/src/components/Media/VideoMedia/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RefreshRouteOnSave"] */ "/app/src/components/RefreshOnRouteSave.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighImpactHero"] */ "/app/src/heros/HighImpact/index.tsx");
